export default __webpack_public_path__ + "static/media/app_store_download_badge.15c405fd.svg";